import "../fieldForce.css";
import back from "../../../assets/back.svg";
import edit from "../../../assets/icons/edit.svg";
import delet from "../../../assets/icons/delete-bin.svg";
import React, { useEffect, useState } from "react";
import VersionHistoryBtn, {
  AdminButton,
} from "../../../components/buttons/versionHistoryBtn";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import DeleteModal from "../../../components/modals/deleteModal";
import { useDispatch } from "react-redux";
import {
  deleteFieldForceDesignation,
  fieldForceFetchDesignationDetail,
} from "../../../redux/actions/fieldForceAction";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import DeletedPopUp from "../../../components/popups/DeletedPopUp";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../../components/utilites/loader";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";

const FieldForceDesignationView = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [designationDetail, setDesignationDetail] = useState(null);
  const [deleteShow, setDeleteShow] = useState(false);
  const [deletedPop, setDeletedPop] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState(null);

  const user_type = localStorage.getItem("userType");
  useEffect(() => {
    if (user_type === "super_user") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      const permissionValue = permissionData?.find(
        (item) => item?.module_name === "Field Force" && item
      );

      setUserData(permissionValue);
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    console.log(params.id);
    dispatch(
      fieldForceFetchDesignationDetail(params.id, onFetchSuccess, onFetchError)
    );
  }, []);

  const onFetchSuccess = (data) => {
    setLoading(false);
    console.log(data.data.data);
    setDesignationDetail(data.data.data);
  };

  const onFetchError = (err) => {
    setLoading(false);
    console.log(err);
  };

  const deleteFn = () => {
    dispatch(
      deleteFieldForceDesignation(
        designationDetail?.id,
        onDelSuccess,
        onDelError
      )
    );
  };

  const onDelSuccess = (data) => {
    setDeleteShow(!deleteShow);
    setDeletedPop(true);

    const timeOutFnc = () => {
      setDeletedPop(false);
      navigate("/field-force/designation");
    };

    setTimeout(timeOutFnc, 2000);
  };
  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onDelError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Edit
    </Tooltip>
  );
  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/field-force/designation",
      breadcrumb: " / field force / designation",
    },
    {
      path: "/field-force/designation/view/:id",
      breadcrumb: designationDetail?.designation_id
        ? ` / ${designationDetail?.designation_id} - view`
        : " / view",
    },
  ];
  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  return (
    <>
      <div className="products-page">
        <div className="products-main-div">
          <div className="mx-3">
            {breadcrumbs.map(({ match, breadcrumb }) => (
              <NavLink
                key={match.pathname}
                to={match.pathname}
                className="header-route-page fw_400 cursor_pointer"
              >
                <span className="fs_18">{breadcrumb}</span>
              </NavLink>
            ))}
          </div>
          <div className="products-main-list my-2 py-1">
            <div className="search-container d-flex justify-content-between align-items-center">
              <div
                className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                onClick={() => navigate(-1)}
              >
                <img src={back} alt="back_btn" />
                <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                  BACK
                </span>
              </div>
              <div className=" d-flex justify-content-between m-1 mb-2">
                <VersionHistoryBtn
                  link={`/field-force/designation/version-history-detail/${designationDetail?.id}`}
                />
                {(user_type == "super_user" && userData?.write) ||
                user_type == "vendor" ? (
                  <>
                    <div className="d-none d-lg-block">
                      <div className="d-flex">
                        <AdminButton
                          background="#7065E4"
                          color="white"
                          width="100px"
                          onClick={() =>
                            navigate(
                              `/field-force/designation/edit/${designationDetail?.id}`
                            )
                          }
                        >
                          <span className="m-2">EDIT</span>
                        </AdminButton>
                        {/* <AdminButton
                        background="#FF6F5B"
                        color="white"
                        width="100px"
                        onClick={() => setDeleteShow(true)}
                      >
                        <span className="m-2">DELETE</span>
                      </AdminButton> */}
                      </div>
                    </div>
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 400 }}
                      overlay={renderTooltip}
                    >
                      <button
                        className="edit-small-btn px-3 mx-1 d-lg-none"
                        onClick={() =>
                          navigate(
                            `/field-force/designation-edit/${designationDetail?.id}`
                          )
                        }
                      >
                        <img src={edit} alt="edit" />
                      </button>
                    </OverlayTrigger>
                    <button
                      className="delete-small-btn px-3 mx-2 me-3 d-lg-none"
                      onClick={() => setDeleteShow(true)}
                    >
                      <img src={delet} alt="delete" />
                    </button>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div style={{ position: "relative" }}>
              {loading == true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : (
                <div className="form-width px-4 ">
                  <div className="my-4">
                    <label className=" Neutral_Color fs_14">
                      Designation ID
                    </label>
                    <p className="fs_14">{designationDetail?.designation_id}</p>
                  </div>

                  <div className="my-4">
                    <label className=" Neutral_Color fs_14">
                      Designation Name
                    </label>
                    <p className="fs_14">{designationDetail?.name}</p>
                  </div>
                  {designationDetail?.approval_level !== "admin" && (
                    <div className="my-4">
                      <label className=" Neutral_Color fs_14">
                        Order Approval Upto
                      </label>
                      <div className="col-10">
                        <p className="fs_14 fn_Nunito">
                          ₹. {designationDetail?.order_approval_upto}
                        </p>
                      </div>
                    </div>
                  )}
                  {designationDetail?.approval_level !== "admin" && (
                    <div className="my-4">
                      <label className=" Neutral_Color fs_14">
                        Order Approval From
                      </label>
                      <div className="col-10">
                        <p className="fs_14 fn_Nunito">
                          ₹. {designationDetail?.order_approval_from}
                        </p>
                      </div>
                    </div>
                  )}
                  {/* <div className="my-4">
                  <label className=" Neutral_Color fs_14">
                    Reporting Designation
                  </label>
                  <p className="fs_14">
                    {designationDetail?.reportingDesignation?.name}
                  </p>
                </div> */}
                  <div className="my-4">
                    <label className=" Neutral_Color fs_14">Levels</label>
                    <p className="fs_14">
                      {designationDetail?.approval_level == "L1" && "Level 1"}
                      {designationDetail?.approval_level == "L2" && "Level 2"}
                      {designationDetail?.approval_level == "L3" && "Level 3"}
                      {designationDetail?.approval_level == "L4" && "Level 4"}
                      {designationDetail?.approval_level == "L5" && "Level 5"}
                      {designationDetail?.approval_level == "L6" && "Level 6"}
                      {designationDetail?.approval_level == "L7" && "Level 7"}
                      {designationDetail?.approval_level == "L8" && "Level 8"}
                      {designationDetail?.approval_level == "L9" && "Level 9"}
                      {designationDetail?.approval_level == "L10" && "Level 10"}
                      {designationDetail?.approval_level == "L11" && "Level 11"}
                      {designationDetail?.approval_level == "L12" && "Level 12"}
                      {designationDetail?.approval_level == "L13" && "Level 13"}
                      {designationDetail?.approval_level == "L14" && "Level 14"}
                      {designationDetail?.approval_level == "L15" && "Level 15"}
                      {designationDetail?.approval_level == "admin" && "Admin"}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <DeleteModal
          title={`this Field Force Designation - ${designationDetail?.designation_id}`}
          show={deleteShow}
          handleClose={() => setDeleteShow(false)}
          delFunc={deleteFn}
        />
        <DeletedPopUp
          title={`Field Force Designation - ${designationDetail?.designation_id}`}
          show={deletedPop}
        />
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
      </div>
    </>
  );
};

export default FieldForceDesignationView;
